<app-alert appCookiebot></app-alert>
<div class="header__fixed" appWalkMe [ngClass]="{'disable-wrapper': !areAllDataLoadedForCheckout}">
  <app-application-bar></app-application-bar>
  <app-navigation-bar></app-navigation-bar>
  @if (!isOnStoreSelection()) {
    <div class="container mini-cart__container">
      <div class="mini-cart" app-mini-cart></div>
    </div>
  }
</div>
<div class="container main-content">
  <app-modal-sap></app-modal-sap>
  @if (!isOnStoreSelection()) {
    <app-breadcrumbs></app-breadcrumbs>
  }
  <router-outlet></router-outlet>
</div>
@if (!isOnStoreSelection()) {
  <app-footer></app-footer>
}
@if (showFullPageLoader) {
  <app-full-page-loader [waitingList]="fullPageLoaderList"></app-full-page-loader>
}
